// extracted by mini-css-extract-plugin
export default {"controls":"ResultsPage_controls__t0M1k","chartRow":"ResultsPage_chartRow__MhKJ2","chartGroup":"ResultsPage_chartGroup__wz5ca"};